import React from 'react';
import { useParams } from 'react-router-dom';
import { images } from '../../constants';
import Rating from '../../Components/Rating/Rating';
import Tag from '../../Components/Tag/Tag';
import AddToCart from '../../Components/AddToCart/AddToCart';
import Counter from '../../Components/QuantityPicker';
import CaloriePercent from '../../Components/CaloriePercent';
import food from '../../utils/data';
import BackButton from '../../Components/BackButton';
import { useSelector } from 'react-redux';

const SingleProductPage = () => {
  const { orderItems } = useSelector((store) => store.order);
  const id = useParams().id;

  const filterFood = food.find((item) => item.id === Number(id));

  return (
    <section className="h-auto lg:h-auto flex flex-col m-6 ">
      <BackButton />

      {food && (
        <div className="flex flex-col lg:flex-row lg:m-10">
          <div className="lg:w-[1000px] w-full">
            <img
              src={filterFood.src}
              alt="food"
              className="my-6 w-[1400px]  rounded-xl"
            />
          </div>
          <div className="flex flex-col  lg:px-16 gap-4 ">
            <div className="flex justify-between font-bold">
              <h3 className="text-4xl text-[#373A40]">{filterFood.foodName}</h3>
              <p className="text-2xl text-[#8ABE53]">
                {filterFood.calories} Cal
              </p>
            </div>
            <div className="flex gap-1">
              <p className="text-[#5C5F66]">{filterFood?.restaurantName}</p>
              <img className="w-1" src={images.ellipse} alt="." />
              <p className="text-[#909296]">{filterFood?.waitingTime} min</p>
            </div>
            <div className="flex gap-4">
              {filterFood.ingredients.map((data) => (
                <p key={data} className="text-[#909296]">
                  {data}
                </p>
              ))}
            </div>

            <div className="flex md:flex-row flex-col gap-6 lg:items-center my-4">
              <Rating checked={filterFood.rating} />
              <div className="flex flex-row gap-6">
                {filterFood.tags &&
                  filterFood.tags.map((data) => <Tag tag={data} key={data} />)}
              </div>
            </div>
            <div className="flex justify-between w-full flex-col gap-10">
              <p className="text-primary-5 font-bold text-[24px]">
                ${filterFood.price}
              </p>
              <div className="flex justify-between items-center">
                {orderItems.map(
                  (item) =>
                    item.id === filterFood.id && (
                      <Counter
                        key={item.id}
                        id={item.id}
                        quantity={item.quantity}
                      />
                    )
                )}
                <AddToCart items={filterFood} />
              </div>
            </div>
            <div className="flex my-6">
              <CaloriePercent
                carbs={filterFood.carbs}
                fats={filterFood.fat}
                protein={filterFood.protein}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default SingleProductPage;
